module.exports = __webpack_public_path__ + "img/kia-hero.15dd2dcf.png";